import React from 'react';

import styles from './EventCard.module.scss';
import FormatDate from "../../../../../components/FormatDate/FormatDate";

const EventCard = (props) => (
  <div className={styles['event-card']}>
    <div className={styles['event-card-header']}>
      <img src={`${process.env.REACT_APP_API_URL}/${props.logo.path}`} alt="" className={styles['event-card__logo']}/>
    </div>
    <div className={styles['event-card-body']}>

      <p className={styles['event-card__date']}>
        <FormatDate format="MMM Do YYYY" date={props.startDate}/>
        {props.endDate ? ' - ' : undefined}
        {props.endDate ?
          <FormatDate format="MMM Do YYYY" date={props.endDate}/>
          : undefined
        }
      </p>
      <h2 className={styles['event-card__name']}>{props.name}</h2>
      <p className={styles['event-card__description']}>
        {props.description}
      </p>
      <a href={props.eventURL}
         target="_blank"
         rel="noopener noreferrer"
         className={styles['event-card__button']}>
        {props.buttonText}
      </a>
    </div>

    {/** Content for Hover State **/}
    <a href={props.eventURL}
       target="_blank"
       rel="noopener noreferrer"
       className={styles['event-card--hover']}>
      <div className={styles['event-card-header']}>
        <img src={`${process.env.REACT_APP_API_URL}/${props.logo.path}`} alt="" className={styles['event-card__logo']}/>
      </div>
      <div className={styles['event-card-body']}>
        <p className={styles['event-card__date']}>
          <FormatDate format="MMM Do YYYY" date={props.startDate}/>
          {props.endDate ? ' - ' : undefined}
          {props.endDate ?
            <FormatDate format="MMM Do YYYY" date={props.endDate}/>
            : undefined
          }
        </p>
        <h2 className={styles['event-card__name']}>{props.name}</h2>
        <p className={styles['event-card__description']}>{props.description}</p>
      </div>
      <span className={styles['event-card__button']}>{props.buttonText}</span>
    </a>
  </div>
);

export default EventCard;